import React from 'react';
import { Outlet } from 'react-router-dom';

function Campaigns() {
  return (
    <div className="campaigns_container">
      <Outlet />
    </div>
  );
}

export default Campaigns;
